import { FormControlLabelProps } from '@mui/material'
import { forwardRef } from 'react'
import { styled } from 'styled-components'

import { HandlerOf } from '../../helpers/typeHelper'
import { Colors } from '../../theme/colors'
import { ErrorMessage, FormControlLabelStyled, StyledCheckbox } from './Checkbox.styles'

export interface CheckboxProps {
  value?: boolean
  onChange?: HandlerOf<boolean>
  label: React.ReactNode
  name?: string
  error?: React.ReactElement | string | boolean
  disabled?: boolean
  className?: string
  inputProps?: any
}

export const Checkbox = forwardRef(
  ({ onChange, value, label, error, name, disabled, className, inputProps }: CheckboxProps, ref: any) => {
    const handleChange: FormControlLabelProps['onChange'] = (_, checked) => {
      onChange?.(checked)
    }

    return (
      <>
        <FormControlLabelStyled
          label={label}
          disabled={disabled}
          className={`${className} checkbox-label`}
          control={
            <StyledCheckbox
              ref={ref}
              checked={value}
              onChange={handleChange}
              name={name}
              $error={Boolean(error)}
              inputProps={inputProps}
            />
          }
        />
        {error && error !== true ? <ErrorMessage>{error}</ErrorMessage> : null}
      </>
    )
  }
)

export const CheckboxBox = styled.div`
  padding: 5px 10px;
  background-color: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  border: 2px solid white;
  transition: border-color 0.2s;

  &:has(.Mui-checked) {
    border-color: ${Colors.cyanD1};
  }

  .MuiFormControlLabel-root {
    margin: 0;
    width: 100%;
  }

  .MuiCheckbox-root {
    opacity: 0;
    order: 1;
    margin-left: auto;
    transition: opacity 0.2s;
  }

  .Mui-checked {
    opacity: 1;
  }
`
